// src/b2b/pages/MyBookings.jsx
import React, { useEffect, useState, useMemo } from 'react';
import { STATUS_LABELS, STATUS_VARIANT } from '../../utils/statusUtils';
import { http } from '../../../api/http';
import BookingDetailsModal from '../../components/BookingDetailsModal';
import { useHistory } from 'react-router-dom';

function fmtDateFR(d) {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return d;
  }
}

const isExpired48h = (createdAt) => {
  if (!createdAt) return true;
  return Date.now() - new Date(createdAt).getTime() > 48 * 60 * 60 * 1000;
};

export default function MyBookings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const history = useHistory();

  async function load(p = 1) {
    setLoading(true);
    setErr(null);
    try {
      const res = await http.get(`/bookings/mine?page=${p}&limit=10`);
      setItems(res.data.items || []);
      setPage(res.data.page || 1);
      setPages(res.data.pages || 1);
    } catch (e) {
      setErr(e?.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load(1);
  }, []);

  if (loading) return <p className="p-3 text-muted">Chargement…</p>;
  if (err) return <p className="p-3 text-danger">Erreur : {err}</p>;

  return (
    <div className="container my-4" style={{ paddingTop: '20px' }}>
      <h2 className="mb-3">Mes réservations</h2>

      {items.length === 0 ? (
        <div className="alert alert-info">Aucune réservation pour le moment.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle">
            <thead>
              <tr>
                <th>Créé le</th>
                <th>Produit</th>
                <th>Destination</th>
                <th>Départ du séjour</th>
                <th>Voyageurs</th>
                <th>Sous-total</th>
                <th>Remise B2b</th>
                <th>Total</th>
                <th>Statut</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {items.map((b) => {
                const currency = b.currency || 'EUR';
                return (
                  <tr key={b._id}>
                    <td>{fmtDateFR(b.createdAt)}</td>
                    <td>
                      <div className="fw-semibold">{b.productName || b.productId || '—'}</div>
                    </td>
                    <td>
                      {b?.destination?.city || '—'}
                      {b?.destination?.country ? `, ${b.destination.country}` : ''}
                    </td>
                    <td>
                      <div>{fmtDateFR(b.stayStartDate)}</div>
                      <div className="text-muted small">
                        {b.from ? `Depuis : ${b.fromLabel}` : ''}
                      </div>
                    </td>
                    <td>
                      {b.adults ?? 0} adulte(s) <br></br> {b.children ?? 0} enfant(s)
                    </td>
                    <td>
                      {b.totalPrice.toFixed(2)} {currency}
                    </td>

                    <td>{b.discountValue > 0 ? `${b.discountValue} %` : 0} </td>
                    <td className="fw-semibold">
                      {b.finalTotalPrice.toFixed(2)} {currency}
                    </td>
                    <td>
                      <span className={`badge bg-${STATUS_VARIANT[b.status] ?? 'warning'}`}>
                        {STATUS_LABELS[b.status] ?? 'En cours'}
                      </span>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-info ms-2 mb-1"
                        onClick={() => setSelectedBooking(b)}
                      >
                        Détails
                      </button>
                      {b.status === 'pending' && (
                        <button
                          type="button"
                          className="btn btn-sm btn-primary ms-2"
                          disabled={isExpired48h(b.createdAt)}
                          onClick={() => history.push(`/b2b/paiement/${b._id}`)}
                        >
                          Continuer le paiement
                        </button>
                      )}

                      {b.status === 'pending' && isExpired48h(b.createdAt) && (
                        <div className="small text-muted mt-1">
                          Réservation expirée (48h dépassées)
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <nav className="d-flex gap-2">
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={page <= 1}
              onClick={() => load(page - 1)}
            >
              ← Précédent
            </button>
            <span className="align-self-center small">
              Page {page} / {pages}
            </span>
            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={page >= pages}
              onClick={() => load(page + 1)}
            >
              Suivant →
            </button>
          </nav>
        </div>
      )}
      {/* Modal détail réservation */}
      {selectedBooking && (
        <BookingDetailsModal
          booking={selectedBooking}
          onClose={() => setSelectedBooking(null)}
        />
      )}
    </div>
  );
}
